/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { UserNotificationState } from './UserNotificationState';
import {
    UserNotificationStateFromJSON,
    UserNotificationStateFromJSONTyped,
    UserNotificationStateToJSON,
} from './UserNotificationState';

/**
 * 
 * @export
 * @interface OwnNotificationListDto
 */
export interface OwnNotificationListDto {
    /**
     * 
     * @type {string}
     * @memberof OwnNotificationListDto
     */
    id?: string;
    /**
     * Tenant Id.
     * @type {number}
     * @memberof OwnNotificationListDto
     */
    tenantId?: number;
    /**
     * 
     * @type {UserNotificationState}
     * @memberof OwnNotificationListDto
     */
    state?: UserNotificationState;
    /**
     * 
     * @type {Date}
     * @memberof OwnNotificationListDto
     */
    createdAt?: dayjs.Dayjs;
    /**
     * 
     * @type {string}
     * @memberof OwnNotificationListDto
     */
    notificationNotificationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OwnNotificationListDto
     */
    notificationDataObjTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OwnNotificationListDto
     */
    notificationDataObjMessage?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OwnNotificationListDto
     */
    targetNotifiersList?: Array<string> | null;
}

/**
 * Check if a given object implements the OwnNotificationListDto interface.
 */
export function instanceOfOwnNotificationListDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OwnNotificationListDtoFromJSON(json: any): OwnNotificationListDto {
    return OwnNotificationListDtoFromJSONTyped(json, false);
}

export function OwnNotificationListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OwnNotificationListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'state': !exists(json, 'state') ? undefined : UserNotificationStateFromJSON(json['state']),
        'createdAt': !exists(json, 'createdAt') ? undefined : (dayjs(json['createdAt'])),

        'notificationNotificationName': !exists(json, 'notificationNotificationName') ? undefined : json['notificationNotificationName'],
        'notificationDataObjTitle': !exists(json, 'notificationDataObjTitle') ? undefined : json['notificationDataObjTitle'],
        'notificationDataObjMessage': !exists(json, 'notificationDataObjMessage') ? undefined : json['notificationDataObjMessage'],
        'targetNotifiersList': !exists(json, 'targetNotifiersList') ? undefined : json['targetNotifiersList'],
    };
}

export function OwnNotificationListDtoToJSON(value?: OwnNotificationListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tenantId': value.tenantId,
        'state': UserNotificationStateToJSON(value.state),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'notificationNotificationName': value.notificationNotificationName,
        'notificationDataObjTitle': value.notificationDataObjTitle,
        'notificationDataObjMessage': value.notificationDataObjMessage,
        'targetNotifiersList': value.targetNotifiersList,
    };
}

